import React, { useState, useEffect } from 'react'
import { CALL_API_OVERDUE } from 'api/Overview/overview'
import styled from 'styled-components'
import { getCookie } from 'helper/cookie'
import { Avatar, Col, Modal, Row } from 'antd'
import {
  InboxOutlined,
  TagsFilled,
} from '@ant-design/icons'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
const OVERDUECONTAINER = styled.div``
const OverdueTask = (props) => {
  const { project_id, project_status_id } = props
  const token = getCookie('access_token_admin')
  const [dataoverdue, setDataoverdue] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [overduemodal, setOverdueModal] = useState(false)
  const history = useHistory()
  const getDataoverdue = async () => {
    setIsLoading(false)
    await CALL_API_OVERDUE({
      project_id: parseInt(project_id),
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setDataoverdue([])

          return true
        }
        if (status === 200) {
          setIsLoading(true)
          await setDataoverdue(data.progress)
        } else {
          setDataoverdue([])
          setIsLoading(true)
          return true
        }
        setIsLoading(true)
      })
      .catch((error) => {
        setDataoverdue([])
        setIsLoading(true)
        console.error(error)
      })
  }
  useEffect(() => {
    if (token) {
      getDataoverdue()
    }
  }, [token])
  const gotoTaskdetail = (vals) => {
    if (project_status_id === 6) {
      history.push({
      pathname: `/taskinbox/${project_id}/${vals}`,
    })
    }

  }

  const [dataonshow, setDataonshow] = useState([])
  const [text, setText] = useState()
  const setShowData = (vals, text) => {
    if (vals != null || vals != undefined) {
      setDataonshow(vals)
      setText(text)
      setOverdueModal(true)
    }
  }
  const overdueOk = () => {
    setOverdueModal(false)
  }
  const overdueCancle = () => {
    setOverdueModal(false)
  }

  return (
    <OVERDUECONTAINER className="overduecontainer-master">
      <h3 className="title-overdue " onClick={() => getDataoverdue()}>
        Overdue Task
      </h3>
      {isLoading === true ? (
        <div>
          {dataoverdue !== null ? (
            <div className="overlayout-scroll">
              {dataoverdue?.map((item) => {
                let colorStyle = '#fff'
                if (item.overdate > 60) {
                  colorStyle = '#bc1216'
                } else if (item.overdate > 30 && item.overdate <= 60) {
                  colorStyle = '#FF6258'
                } else {
                  colorStyle = '#ffaf00'
                }
                return (
                  <div className="box-row">
                    <Row className="rowitem1">
                      <Col className="coldate">
                        <span className={'small date'} style={{ color: colorStyle }}>
                          <div
                            style={{
                              display: 'grid',
                              maxWidth: 20,
                              overflow: 'hidden',
                              marginRight: 4,
                            }}
                          >
                            {item.overdate}
                          </div>
                          days
                        </span>
                        <span className="small start-date">
                          {moment(item.plan_end).format('DD MMM YYYY')}
                        </span>
                      </Col>
                      <Col className="in-rowitem1">
                        <div style={{ display: 'grid' }}>
                          <p
                            className="title-row cutter-text-line-1"
                            onClick={() => gotoTaskdetail(item.sprintflow_id)}
                            style={{ cursor: 'pointer' }}
                          >
                            {item.title}
                          </p>
                        </div>
                        <span className="smallStatus normalsubtasks-count">
                          {item.count_subtask} subtasks
                        </span>
                      </Col>
                    </Row>
                    <Row className="rowitem2" style={{ height: '100%' }}>
                      <Row>
                        <span
                          className="small start-date"
                          style={{
                            minWidth: '68px',
                          }}
                        >
                          {moment(item.plan_end).format('DD MMM YYYY')}
                        </span>
                        <span className="smallStatus responssubtasks-count">
                          {item.count_subtask} subtasks
                        </span>
                      </Row>

                      <div
                        onClick={() => setShowData(item.member, item.title)}
                        style={{ cursor: 'pointer' }}
                      >
                        <Avatar.Group
                          className="group-user"
                          maxCount={3}
                          size="default"
                          maxStyle={{
                            color: '#ffffff',
                            backgroundColor: '#6DB9FF',
                          }}
                        >
                          {item.member?.map((memberdata, idx) => {
                            return <Avatar src={memberdata.pic_display}></Avatar>
                          })}
                        </Avatar.Group>
                      </div>
                    </Row>
                  </div>
                )
              })}
            </div>
          ) : (
            <div className="overlayout-scroll">
              <div className="emytystate edit-height-emptystate">
                <InboxOutlined className="inbox " />
                <p>No Overdue Task</p>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="overlayout-scroll"></div>
      )}
      <Modal
        className="modalNoBtn responsive-width-overdue"
        visible={overduemodal}
        onOk={overdueOk}
        onCancel={overdueCancle}
        title={
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <h2>Overdue Member List</h2>
            <Row style={{ marginTop: 8 }}>
              <TagsFilled style={{ marginRight: 8, color: '#127ec3' }} />
              <div style={{ display: 'grid', maxWidth: '70%' }}>
                <p className="cutter-text-line-1 ">{text}</p>
              </div>
            </Row>
          </div>
        }
      >
        <div className="styleshowlist-personal">
          {dataonshow.map((item) => {
            return (
              <div className="row-personal-styles">
                <Col className="image-area">
                  <img className="imageStyle" src={item.pic_display}></img>
                </Col>
                <Col className="personal-area">
                  <Row className="one-area" style={{ flexWrap: 'nowrap' }}>
                    <div style={{ display: 'grid' }}>
                      <p className="cutter-text-line-1 ">
                        {item.firstname}{' '}
                      {item.lastname}
                    </p>
                    </div>

                    <span className="small" style={{ minWidth: 'fit-content' }}>{item.role}</span>
                  </Row>
                  <Row className="two-area">
                    <span className="smallStatus">{item.permission_name}</span>
                  </Row>
                </Col>
              </div>
            )
          })}
        </div>
      </Modal>
    </OVERDUECONTAINER>
  )
  // }
}

export default OverdueTask
